import React from "react";
import { Tooltip } from "@mui/material";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import { formatLocation, mapLink, locationTitle, hasCoords } from "../../helpers/geolocation";
import "./Attendance.scss";

/* Where a punch happened. Nothing renders when no location was recorded — an
   older row, or someone who refused the prompt — so it can be dropped beside
   any time without a guard at the call site. */
const LocationPin = ({ location, label, withText = false }) => {
    if (!hasCoords(location)) return null;

    return (
        <Tooltip title={locationTitle(location, label)} placement="top" arrow>
            <a className="att-place" href={mapLink(location)}
                target="_blank" rel="noopener noreferrer">
                <PlaceOutlinedIcon />
                {withText && <span>{formatLocation(location)}</span>}
            </a>
        </Tooltip>
    );
};

export default LocationPin;
